<template>
    
    
    
    
    
    
    
    
    
    
    
    <svg class="icon" height="20" p-id="5910" t="1647071960484" title="字节跳动小程序" version="1.1" viewBox="0 0 1024 1024" width="20" xmlns="http://www.w3.org/2000/svg" style="margin-left: 0px;"><title>字节跳动小程序</title><path d="M582.4 72H441.6v401.66L76.4 674.17l69.77 115.66L512 589.31l365.83 200.52 69.77-115.66-365.2-200.51z m0 0" fill="#DDDFE8" p-id="5911"></path>
    <path d="M441.6 732h140.8v220H441.6zM75.77 349.83l200.52 110 70.4-115.66-200.52-110-70.4 115.66z m802.06-115.66l-200.52 110 70.4 115.66 200.52-110-70.4-115.66z" fill="#DDDFE8" p-id="5912"></path></svg>
</template>

